import Vue from "vue";
import D from "debug";
import includes from "lodash/includes";
import filter from "lodash/filter";
import router from "../router";

const debug = D("ciris:errores.js");
let erroresActivos = [];

export default generarErrores;

function generarErrores(modulo) {
  const errores = {
    0: {
      titulo: "Desconectado",
      mensaje: "Sin conexión a internet",
    },
    200: {
      titulo: "Éxito",
      mensaje: "Éxito en el proceso",
    },
    201: {
      titulo: "Creado",
      mensaje: `Se ha creado el ${modulo}`,
    },
    202: {
      titulo: "Aceptado",
      mensaje: "El proceso se ha recibido y se está procesando",
    },
    400: {
      titulo: "Petición invalida",
      mensaje: "Se realizó una petición invalida, revise la información e intente nuevamente",
    },
    401: {
      titulo: "Credenciales invalidos",
      mensaje: "No tiene los credenciales para completar este pedido",
    },
    403: {
      titulo: "Prohibido",
      mensaje: "No posee los permisos para hacer este pedido",
    },
    404: {
      titulo: "No encontrado",
      mensaje: "No se encuentra lo que buscaba",
    },
    408: {
      titulo: "Tiempo agotado",
      mensaje: "Se tomó demasiado enviando el pedido, revise su conección e intente nuevamente",
    },
    409: {
      titulo: "Conflicto",
      mensaje: "Revise que la información ingresada sea la correcta y que todo esté lleno",
    },
    413: {
      titulo: "Pedido demasiado grande",
      mensaje: "El pedido realizado es demasiado grande y no puede ser aceptado",
    },
    415: {
      titulo: "Token vencido",
      mensaje: "Tiene que volver a loguearse para poder usar el sistema",
      accionExtra() {
        Vue.prototype.$auth.logout();
        router.push({ name: "login" });
      },
    },
    429: {
      titulo: "Demasiados pedidos",
      mensaje: "Se han recibido demasiadas peticiones desde su computadora, por favor intente más tarde",
    },
    500: {
      titulo: "Error de servidor",
      mensaje: "Ha ocurrido un error en el servidor",
    },
    501: {
      titulo: "No implementado",
      mensaje: "El servicio solicitado no ha sido implementado",
    },
    503: {
      titulo: "Sin recursos",
      mensaje: "El servidor no se encuentra disponible o está sobrecargado, por favor intente más tarde",
    },
    504: {
      titulo: "Tiempo agotado",
      mensaje: "El servidor está tomando más de lo normal en responder",
    },
  };
  return (tipo, evento) => {
    const status = evento ? evento.status || evento.response.status : 0;
    if (!includes(erroresActivos, status)) {
      const { mensaje } = errores[status];
      const { titulo } = errores[status];
      if (errores[status].accionExtra) {
        errores[status].accionExtra();
      }
      erroresActivos.push(status);
      debug(erroresActivos);
      setTimeout(() => { erroresActivos = filter(erroresActivos, status); }, 5000);
      return Vue.prototype.$toastr(
        tipo,
        `${status} - ${mensaje}`,
        titulo,
      );
    }
    return false;
  };
}
